import React, { Component } from 'react';
import { HashRouter as Router, Route, Redirect } from 'react-router-dom'
import Homepage from "./Homepage"
import Article from "./Article"

class App extends Component {
  constructor() {
    super();
    this.state = {
    }
  }
  render() {
    return (
      <div className="App">
        <Router basename="/">
          <div>
            <Route exact path="/" component={Homepage} />
            <Route path="/Article/:id" component={Article} />
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx